module.exports = __webpack_public_path__ + "static/media/OutOfStockScreen.09c9bcf2.png";